<div
	class="bp-service builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
>
	<div
		class="bp-service builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
	>
		<h2
			[style.text-align]="data.page_service.props && data.page_service.props[0] && data.page_service.props[0].align ? data.page_service.props[0].align : 'initial'"
			[style.color]="data.page_service.props && data.page_service.props[0] && data.page_service.props[0].color ? data.page_service.props[0].color : 'initial'"
			[style.font-weight]="data.page_service.props && data.page_service.props[0] && data.page_service.props[0].style ? data.page_service.props[0].style : 'initial'"
			class="m-bottom-20"
		>
			{{ data.page_service.title }}
		</h2>
		<img
			class="service-image d-md-flex d-md-none"
			[class.large-only]="data.page_service.thumbnail_mobile && data.page_service.thumbnail_mobile.url"
			[src]="data.page_service.thumbnail.url"
			:lazy-src="data.page_service.thumbnail.thumb_url"
			[alt]="data.page_service.thumbnail.custom_properties.alt_text"
			[height]="data.page_service.thumbnail.height"
			[width]="data.page_service.thumbnail.width"
		>
		<img *ngIf="data.page_service.thumbnail_mobile && data.page_service.thumbnail_mobile.url"
			class="service-image d-sm-flex d-md-none small-only"
			[src]="data.page_service.thumbnail_mobile.url"
			[alt]="data.page_service.thumbnail_mobile.custom_properties.alt_text"
			[height]="data.page_service.thumbnail_mobile.height"
			[width]="data.page_service.thumbnail_mobile.width"
		>
	</div>
</div>